'use strict'
import axios from 'axios'
import { getBaseUrl } from './getBaseUrl'

const URL = () => {
    const url = getBaseUrl()
    if (url) 
        return url

    if (process.env.VUE_APP_API_URL)
        return process.env.VUE_APP_API_URL

    switch (process.env.VUE_APP_NODE_ENV) {
    case 'production':
        return 'https://moezdorovie.org'
    case 'smev':
        return 'https://smev.moezdorovie.org'
    case 'development':
        return 'http://localhost:3200'
    default:
        return 'https://moezdorovie.org'
    }
}

const http = axios.create({
    baseURL: `${URL()}/api/v3`,
    'Content-Type': 'application/json'
})

export const login = (data) => http.post('/auth/login', data)
export const verify = (data) => http.post('/auth/verify', data)
export const captcha = () => http.get('/captcha')
export const sendCaptcha = (data) => http.post(`/captcha`, data)
